export enum PaymentType {
  CREDIT_CARD = 'creditCard'
}
